module.exports = __webpack_public_path__ + "img/right-caijiazhen.3966aa50.png";